import api from "../api";

export async function listarArquivosQuestaoResposta(IDQuestao_Secao) {
  try {
    const response = await api.get(
      `/chkquestaorespostaarquivo/questaosecao/${IDQuestao_Secao}`
    );
    return response.data?.arquivos || [];
  } catch (error) {
    console.error("Falha ao listar anexos da questão", error);
    return [];
  }
}

export async function buscarDiretorioAnexosQuestao(IDQuestao_Secao) {
  const response = await api.get(
    `/chkquestaorespostaarquivo/questaosecao/${IDQuestao_Secao}/diretorio`
  );
  return response.data?.diretorio || null;
}

export async function vincularArquivosQuestaoResposta({
  IDQuestao_Secao,
  IDQuestao_Resposta = null,
  IDArquivos,
  IDCriador,
}) {
  const response = await api.post("/chkquestaorespostaarquivo/batch", {
    IDQuestao_Secao,
    IDQuestao_Resposta,
    IDArquivos,
    IDCriador,
  });

  return response.data?.registros || [];
}

export async function excluirArquivoQuestaoResposta({
  IDChkQuestaoResposta_Arquivo,
  tipoPermissao,
}) {
  const response = await api.delete(
    `/chkquestaorespostaarquivo/${IDChkQuestaoResposta_Arquivo}`,
    {
      data: { tipoPermissao },
    }
  );

  return response.data || null;
}

export async function uploadArquivosQuestaoResposta({
  arquivos,
  IDDiretorio,
  bucketName,
  tipoPermissao,
  IDCriador,
}) {
  const uploadId = crypto.randomUUID();
  const formData = new FormData();

  formData.append("uploadId", uploadId);
  formData.append("IDDiretorio", String(IDDiretorio));
  formData.append("tipoPermissao", String(tipoPermissao));
  formData.append("bucketName", bucketName);
  formData.append("IDCriador", String(IDCriador));

  const arquivosInfo = arquivos.map((arquivo) => ({
    key: crypto.randomUUID(),
    clientId: `${arquivo.name}-${crypto.randomUUID()}`,
    originalName: arquivo.name,
    size: arquivo.size,
  }));

  formData.append("arquivosInfo", JSON.stringify(arquivosInfo));
  arquivos.forEach((arquivo) =>
    formData.append("arquivos", arquivo, arquivo.name)
  );

  const response = await api.post("/upload-direto", formData);
  return response.data?.arquivos || [];
}
